import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { Lojistik } from 'src/model/lojistik';
import { LojistikFiyatArsiv } from 'src/model/lojistik-fiyat-arsiv';
import { RestService } from 'src/providers/rest.service';

@Component({
  selector: 'app-lojistik-rota-fiyatlar',
  templateUrl: './lojistik-rota-fiyatlar.component.html',
  styleUrls: ['./lojistik-rota-fiyatlar.component.css']
})
export class LojistikRotaFiyatlarComponent implements OnInit {

  id: number;
  lojistik: Lojistik = new Lojistik();
  private subscriptions: Subscription[] = [];
  arsiv: LojistikFiyatArsiv;

  constructor(private restService: RestService, private route: ActivatedRoute) { }

  ngOnInit() {
    this.subscriptions.push(this.route.queryParams.subscribe(params => {
      this.id = params.id;
      this.restService.getLojistikRotaFiyat(this.id).subscribe(res => {
        this.lojistik = res;
      });

      this.restService.getLojistikFiyatArsiv().subscribe(res => {
        this.arsiv = res;
        this.arsiv.fiyat = res[0].fiyat;
      });
    }));
  }

  degisimHesapla() {
    this.restService.getLojistikRotaFiyatArsiv(this.id, this.arsiv.fiyat).subscribe(res => {
      this.lojistik = res;
    });
  }
}
